module.exports = __webpack_public_path__ + "img/location.c3767336.png";